import { LabelProps } from 'components/customer/CompanyCard/ReadOnlyRow'
import colors from 'styles/colors.json'

function Header({ label, more, icon }) {
  return (
    <div
      style={{
        borderBottom: `1px solid ${colors['color-navy-light']}`,
        padding: '10px 20px'
      }}
      className="flex-space-between"
    >
      <div className="flex">
        {icon}
        <span {...LabelProps}>{label}</span>
      </div>
      {more}
    </div>
  )
}

export default Header



// WEBPACK FOOTER //
// ./src/scripts/components/customer/CompanyCard/Header.js